import React from 'react'
import './index.css'

const CoverImg = ({ src, alt, position = 'center', className, disclaimer = false, disclaimerClassName }) =>
  <div className={`cover-img relative w-100 ${className}`} style={{ background: `url(${src})`, backgroundPosition: position }}>
    {disclaimer && <div className={`cover-img__disclaimer absolute fw2 ${disclaimerClassName}`}>Fictionalized Depiction</div>}
  </div>

export default CoverImg



// WEBPACK FOOTER //
// ./src/components/cover-img/index.js